import useRequest from 'core/hooks/useRequest';

export default (batId) => {
  return useRequest({
    queryKey: ['batId', 'getProfile'],
    queryFn: ({ queryKey: [, method, params] }) => batId[method](params),
  });
};
